import { useAuth0 } from '@auth0/auth0-react';

export const useGetAccountId = () => {
  const { user } = useAuth0();
  const accountId = user?.['https://tacklit.com/accountId'];
  return { accountId };
};
